import { render, staticRenderFns } from "./TaskAssignmentReview.vue?vue&type=template&id=b35cfef6&scoped=true"
import script from "./TaskAssignmentReview.vue?vue&type=script&lang=js"
export * from "./TaskAssignmentReview.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignmentReview.vue?vue&type=style&index=0&id=b35cfef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35cfef6",
  null
  
)

export default component.exports